module.exports = __webpack_public_path__ + "img/265.d0894783.png";